export default {
  LOADING_DASHBOARD: 'Chargement du tableau de bord',
  MISSING_PERMISSIONS: `Vous n'avez pas les permissions requises pour afficher les données de cette section.`,
  dailyUpdate: {
    TITLE: `Résumé de la journée`,
    SUMMARY: `Cette section vous permet de voir l'état de la journée en cours.`,
    UNFILLEDSHIFTSTODAY: `Quarts de travail non comblés <0>{{ count }} quart</0>`,
    UNFILLEDSHIFTSTODAY_other: `Quarts de travail non comblés <0>{{ count }} quarts</0>`,
    REPLACEDSHIFTSTODAY: `Quarts de travail remplacés <0>{{ count }} quart</0>`,
    REPLACEDSHIFTSTODAY_other: `Quarts de travail remplacés <0>{{ count }} quarts</0>`,
    ABSENCESTODAY: `Absences <0>{{ count }} requête</0>`,
    ABSENCESTODAY_other: `Absences <0>{{ count }} requêtes</0>`,
    LATESTODAY: `Retards <0>{{ count }} requête</0>`,
    LATESTODAY_other: `Retards <0>{{ count }} requêtes</0>`,
    EARLYOUTTODAY: `Départs hâtifs <0>{{ count }} requête</0>`,
    EARLYOUTTODAY_other: `Départs hâtifs <0>{{ count }} requêtes</0>`
  },
  actionsToDo: {
    TITLE: `Actions à faire`,
    SUMMARY: `Cette section vous résume les tâches restantes à faire dans le logiciel.`,
    ATTENDANCEREQUESTSINPROGRESS: `Requêtes d'absences à recevoir <0>{{ count }} requête</0>`,
    ATTENDANCEREQUESTSINPROGRESS_other: `Requêtes d'absences à recevoir <0>{{ count }} requêtes</0>`,
    TIMEOFFREQUESTSINPROGRESS: `Congés à approuver <0>{{ count }} requête</0>`,
    TIMEOFFREQUESTSINPROGRESS_other: `Congés à approuver <0>{{ count }} requêtes</0>`,
    AVAILABILITYREQUESTSTOAPPROVE: `Disponibilités à approuver <0>{{ count }} requête</0>`,
    AVAILABILITYREQUESTSTOAPPROVE_other: `Disponibilités à approuver <0>{{ count }} requêtes</0>`,
    PUNCHCARDSNEEDACTION: `Cartes de temps à valider <0>{{ count }} carte</0>`,
    PUNCHCARDSNEEDACTION_other: `Cartes de temps à valider <0>{{ count }} cartes</0>`
  },
  quickActions: {
    TITLE: `Actions rapides`,
    SUMMARY: `Cette section vous permet de naviguer rapidement vers certaines pages de l'application.`,
    CREATEUSERACTION: `Créer un utilisateur`,
    CREATEPUNCHCARDACTION: `Créer une carte de temps`,
    CREATEATTENDANCEACTION: `Créer une requête d'absence`,
    CREATETIMEOFFACTION: `Créer un congé`,
    CREATELISTFORTODAYACTION: `Créer une liste avec les quarts non-assignés d'aujourd'hui`,
    CREATELISTFORTOMORROWACTION: `Créer une liste avec les quarts non-assignés de demain`
  }
}
